import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { Boletines } from '@app/shared';


@Injectable()
export class PublicatiosBulletinsDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }



  /**
   * Metodo que devuelve todas los boletines
   *
   * @param {number} id
   * @return {*}  {Observable<Boletines[]>}
   * @memberof PublicatiosBulletinsDataService
   */
  getBulletins(): Observable<Boletines[]> {
    return new Observable(obs => {
      //this.http.skipErrorHandler().get<Boletines[]>(this.api.get('adminBulletin')).subscribe(
        this.http.skipErrorHandler().get<Boletines[]>(this.api.get('adminBulletin')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/shared/publicatios-bulletins.data.service.ts